import React from 'react';
import { translate } from '@utils/i18n';
import { Controller, useFormContext } from 'react-hook-form';
import Recurrence from './recurrence';
function AdvancedSection() {
    const namespace = 'features.modals.new_generic_event_modal.advanced_section';
    const { control, watch } = useFormContext();
    const formValues = watch();
    return (React.createElement("div", { className: "advancedSection" },
        React.createElement(Controller, { name: "conflictable", control: control, render: ({ field }) => (React.createElement("div", { className: "qmb-checkbox" },
                React.createElement("input", { id: field.name, type: "checkbox", checked: field.value, onChange: field.onChange }),
                React.createElement("label", { htmlFor: field.name, className: "qmb-label" }, translate('show_as_busy', { namespace })))) }),
        React.createElement(Controller, { name: "isRecurring", control: control, render: ({ field }) => (React.createElement("div", { className: "qmb-checkbox" },
                React.createElement("input", { id: field.name, type: "checkbox", checked: field.value, onChange: field.onChange }),
                React.createElement("label", { htmlFor: field.name, className: "qmb-label" }, translate('is_recurring', { namespace })))) }),
        formValues.isRecurring && React.createElement(Recurrence, null)));
}
export default AdvancedSection;
